export default __webpack_public_path__ + "img/83a6c51f88291ee0647d299f10388f88.svg";